<div class="container-fluid p-4">
  <!-- Spinner de carga inicial -->
  <div *ngIf="loading" class="text-center my-5">
    <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
      <span class="visually-hidden">Cargando...</span>
    </div>
    <p class="mt-3 text-muted">Cargando polígonos...</p>
  </div>

  <div *ngIf="!loading" class="card shadow-sm">
    <div class="card-header bg-dark">
      <h4 class="mb-0 text-white"><i class="fas fa-history me-2"></i>Historial de Apertura y Cierre de Polígonos</h4>
    </div>
    <div class="card-body">
      <!-- Filtros -->
      <div class="row mb-4 align-items-center g-3">
        <div class="col-lg-7 col-md-8 col-sm-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>
              <i class="fas fa-map-marked-alt me-2"></i>Seleccione un Polígono
            </mat-label>
            <input type="text"
                   matInput
                   [formControl]="filtroPoligono"
                   [matAutocomplete]="auto"
                   placeholder="Buscar polígono"
                   [disabled]="loading">
            <mat-autocomplete #auto="matAutocomplete"
                              [displayWith]="displayPoligono"
                              (optionSelected)="onPoligonoSelected($event)">
              <mat-option *ngFor="let poligono of poligonosFiltrados | async" [value]="poligono">
                <span class="option-content">
                  <strong>{{poligono.COD_POLIGONO}}</strong> - {{poligono.NOMBRE_POLIGONO}}
                  <span class="badge ms-2"
                        [class.bg-success]="poligono.ESTADO_LEGIBLE === 'Activo'"
                        [class.bg-secondary]="poligono.ESTADO_LEGIBLE !== 'Activo'">
                    {{poligono.ESTADO_LEGIBLE}}
                  </span>
                </span>
              </mat-option>
            </mat-autocomplete>
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
        </div>
        <div class="col-auto ms-auto" *ngIf="selectedPoligonoId">
          <button type="button" class="btn btn-outline-primary" (click)="verMovimientos()">
            <i class="fas fa-history me-2"></i>Ver movimientos del polígono
          </button>
        </div>
      </div>

      <!-- Spinner de carga historial -->
      <div *ngIf="loadingHistorial" class="text-center my-5">
        <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
        <p class="mt-3 text-muted">Cargando historial...</p>
      </div>

      <!-- Último monitoreo del polígono -->
      <div *ngIf="!loadingHistorial && historial.length > 0">
        <div class="alert alert-info d-flex align-items-center aviso-monitoreo" role="alert">
          <i class="fas fa-robot me-2 fs-5"></i>
          <div>Lo que ves aquí corresponde al <strong>último barrido realizado por el proceso automático de monitoreo</strong>, no necesariamente al estado en tiempo real del polígono.</div>
        </div>
        <div class="monitoreo-list">
          <div class="monitoreo-card" *ngFor="let item of historial">
          <div class="monitoreo-card-header">
            <div class="monitoreo-card-title">
              <i class="fas fa-warehouse me-2 text-muted"></i>
              Bodega <strong>{{ item.COD_BODEGA }}</strong>
              <span class="separator">·</span>
              <i class="fas fa-calendar-day me-1 text-muted"></i>
              Picking <strong>{{ formatDateOnly(item.FECHA_PICKING) }}</strong>
              <span class="separator">·</span>
              <span class="text-muted">ID {{ item.ID_MONITOREO }}</span>
            </div>
            <span class="badge fs-6"
                  [class.bg-danger]="item.ESTADO_APERTURA === 'C'"
                  [class.bg-success]="item.ESTADO_APERTURA === 'A'">
              <i [class.fas]="true"
                 [class.fa-lock]="item.ESTADO_APERTURA === 'C'"
                 [class.fa-lock-open]="item.ESTADO_APERTURA === 'A'"
                 class="me-1"></i>
              {{ getEstadoLabel(item.ESTADO_APERTURA) }}
            </span>
          </div>

          <div class="monitoreo-card-body">
            <div class="monitoreo-section">
              <h6 class="section-title">Ocupación</h6>
              <div class="metric-row">
                <span class="metric-label"><i class="fas fa-cube me-1"></i>Cubicaje</span>
                <span class="metric-value"
                      [class.text-danger]="item.CUBICAJE_OCUPADO > item.CUBICAJE_TOTAL"
                      [class.fw-bold]="item.CUBICAJE_OCUPADO > item.CUBICAJE_TOTAL">
                  {{ formatNumber(item.CUBICAJE_OCUPADO) }} / {{ formatNumber(item.CUBICAJE_TOTAL) }}
                  <i *ngIf="item.CUBICAJE_OCUPADO > item.CUBICAJE_TOTAL" class="fas fa-exclamation-triangle ms-1"></i>
                </span>
              </div>
              <div class="metric-row">
                <span class="metric-label"><i class="fas fa-list-ol me-1"></i>Órdenes</span>
                <span class="metric-value"
                      [class.text-danger]="item.CANTIDAD_ORD_OCUPADA > item.CANTIDAD_ORD_TOTAL"
                      [class.fw-bold]="item.CANTIDAD_ORD_OCUPADA > item.CANTIDAD_ORD_TOTAL">
                  {{ item.CANTIDAD_ORD_OCUPADA }} / {{ item.CANTIDAD_ORD_TOTAL }}
                  <i *ngIf="item.CANTIDAD_ORD_OCUPADA > item.CANTIDAD_ORD_TOTAL" class="fas fa-exclamation-triangle ms-1"></i>
                </span>
              </div>
            </div>

            <div class="monitoreo-section">
              <h6 class="section-title">Trazabilidad</h6>
              <div class="trace-row">
                <i class="fas fa-plus-circle text-primary"></i>
                <div>
                  <span class="trace-label">Creación</span>
                  <div class="user-info">
                    <strong>{{ item.USUARIO_CREACION || '-' }}</strong>
                    <small class="text-muted ms-1">{{ formatDate(item.FECHA_CREACION) }}</small>
                  </div>
                </div>
              </div>
              <div class="trace-row">
                <i class="fas fa-lock text-danger"></i>
                <div>
                  <span class="trace-label">Cierre</span>
                  <div class="user-info">
                    <strong>{{ item.USUARIO_CIERRE || '-' }}</strong>
                    <small class="text-muted ms-1">{{ formatDate(item.FECHA_CIERRE) }}</small>
                  </div>
                </div>
              </div>
              <div class="trace-row">
                <i class="fas fa-lock-open text-success"></i>
                <div>
                  <span class="trace-label">Apertura</span>
                  <div class="user-info">
                    <strong>{{ item.USUARIO_APERTURA || '-' }}</strong>
                    <small class="text-muted ms-1">{{ formatDate(item.FECHA_APERTURA) }}</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>

      <!-- Mensaje cuando no hay datos -->
      <div *ngIf="!loadingHistorial && selectedPoligonoId && historial.length === 0"
           class="alert alert-info d-flex align-items-center" role="alert">
        <i class="fas fa-info-circle me-2 fs-4"></i>
        <div>No hay historial disponible para el polígono seleccionado.</div>
      </div>
      <div *ngIf="!selectedPoligonoId && !loadingHistorial"
           class="alert alert-secondary d-flex align-items-center" role="alert">
        <i class="fas fa-hand-pointer me-2 fs-4"></i>
        <div>Seleccione un polígono para ver su historial.</div>
      </div>
    </div>
  </div>
</div>
